import cn from 'classnames';
import React from 'react';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';
import logoHager from '@/ebat/assets/logos/hager.png';

// Image component for the eBAT logo to fix a problem with the safari browser and IOS on the SVG logo
const LogoHager = ({ className }) => (
  <img alt="Hager" className={cn('logo-hager', className)} src={logoHager} />
);

LogoHager.defaultProps = {
  ...ClassNameDefaultProps,
};

LogoHager.propTypes = {
  ...ClassNamePropTypes,
};

export default LogoHager;
